/**
 * Boost PFS Search Translation Integration
 * 
 * This script intercepts search queries for non-German language versions
 * and translates them to German before sending to the mybcapps search API.
 * 
 * Integration with GTranslate/TranslateX API
 * Version: 1.4.0 - Comprehensive dictionaries for EN, FR, IT
 */
(function() {
  'use strict';

  // Configuration
  var TRANSLATEX_API_KEY = 'AIzaTXUhEZMh4Dibpy6F1vfMbSYipXjvpTALfq9';
  var TRANSLATEX_API_URL = 'https://api.translatex.com/translate';
  var DEFAULT_LANGUAGE = 'de';
  var CACHE_PREFIX = 'boost_translate_';
  var CACHE_EXPIRY = 24 * 60 * 60 * 1000; // 24 hours

  // Translation queue for pending translations
  var pendingTranslations = {};

  /**
   * Comprehensive product dictionary for baby/kids products
   * Based on actual site navigation and product categories
   */
  var PRODUCT_DICTIONARY = {
    // English to German
    'en': {
      // === MAIN MENU CATEGORIES ===
      'new': 'Neu',
      'winter': 'Winter',
      "children's furniture": 'Kindermöbel',
      'childrens furniture': 'Kindermöbel',
      'kids furniture': 'Kindermöbel',
      'home & decor': 'Home & Deko',
      'home and decor': 'Home & Deko',
      'decor': 'Deko',
      'decoration': 'Dekoration',
      'baby essentials': 'Babyausstattung',
      'baby equipment': 'Babyausstattung',
      'strollers & car seats': 'Kinderwagen & Autositze',
      'strollers and car seats': 'Kinderwagen & Autositze',
      'fashion': 'Mode',
      'play': 'Spielen',
      'inspiration': 'Inspiration',
      'gifts': 'Geschenke',
      'gift': 'Geschenk',
      'sale': 'Sale',
      'brands': 'Marken',
      'brand': 'Marke',
      
      // === FURNITURE CATEGORIES ===
      'furniture': 'Möbel',
      'nursery': 'Kinderzimmer',
      'baby room': 'Babyzimmer',
      "children's room": 'Kinderzimmer',
      'childrens room': 'Kinderzimmer',
      'kids room': 'Kinderzimmer',
      'playroom': 'Spielzimmer',
      'bed': 'Bett',
      'beds': 'Betten',
      'baby bed': 'Babybett',
      'crib': 'Babybett',
      'cot': 'Babybett',
      'cradle': 'Wiege',
      'bassinet': 'Stubenwagen',
      'toddler bed': 'Kinderbett',
      'junior bed': 'Juniorbett',
      'bunk bed': 'Etagenbett',
      'loft bed': 'Hochbett',
      'house bed': 'Hausbett',
      'floor bed': 'Bodenbett',
      'canopy': 'Betthimmel',
      'bed canopy': 'Betthimmel',
      'mattress': 'Matratze',
      'mattresses': 'Matratzen',
      'pillow': 'Kissen',
      'pillows': 'Kissen',
      "children's pillow": 'Kinderkopfkissen',
      'bedding': 'Bettwäsche',
      'bed linen': 'Bettwäsche',
      'duvet': 'Bettdecke',
      'comforter': 'Bettdecke',
      'sheet': 'Bettlaken',
      'sheets': 'Bettlaken',
      'fitted sheet': 'Spannbettlaken',
      'bed nest': 'Bettnestchen',
      'bumper': 'Nestchen',
      'bed bumper': 'Bettnestchen',
      'wardrobe': 'Kleiderschrank',
      'closet': 'Schrank',
      'dresser': 'Kommode',
      'chest of drawers': 'Kommode',
      'drawer': 'Schublade',
      'shelf': 'Regal',
      'shelves': 'Regale',
      'bookshelf': 'Bücherregal',
      'changing table': 'Wickeltisch',
      'changing mat': 'Wickelauflage',
      'changing pad': 'Wickelauflage',
      'at the changing table': 'Am Wickeltisch',
      'desk': 'Schreibtisch',
      'at the desk': 'Am Schreibtisch',
      'chair': 'Stuhl',
      'chairs': 'Stühle',
      'table': 'Tisch',
      'tables': 'Tische',
      'lamp': 'Lampe',
      'lamps': 'Lampen',
      'night light': 'Nachtlicht',
      'nightlight': 'Nachtlicht',
      'rug': 'Teppich',
      'rugs': 'Teppiche',
      'carpet': 'Teppich',
      'curtain': 'Vorhang',
      'curtains': 'Vorhänge',
      
      // === STROLLERS & MOBILITY ===
      'stroller': 'Kinderwagen',
      'strollers': 'Kinderwagen',
      'pram': 'Kinderwagen',
      'pushchair': 'Kinderwagen',
      'buggy': 'Buggy',
      '3 wheel stroller': '3 Rad Kinderwagen',
      'three wheel stroller': '3 Rad Kinderwagen',
      'car seat': 'Autositz',
      'car seats': 'Autositze',
      'infant car seat': 'Babyschale',
      'baby car seat': 'Babyschale',
      'baby carrier': 'Babytrage',
      'carrier': 'Trage',
      'baby wrap': 'Tragetuch',
      'sling': 'Tragetuch',
      'carrycot': 'Babywanne',
      'bassinet stroller': 'Babywanne',
      
      // === FEEDING ===
      'high chair': 'Hochstuhl',
      'highchair': 'Hochstuhl',
      'feeding chair': 'Hochstuhl',
      'learning tower': 'Lernturn',
      'learningtower': 'Lernturn',
      'booster seat': 'Sitzerhöhung',
      'baby bottle': 'Babyflasche',
      'bottle': 'Flasche',
      'bottles': 'Flaschen',
      'bib': 'Lätzchen',
      'bibs': 'Lätzchen',
      'sippy cup': 'Trinklernbecher',
      'cup': 'Becher',
      'plate': 'Teller',
      'bowl': 'Schüssel',
      'cutlery': 'Besteck',
      'spoon': 'Löffel',
      'fork': 'Gabel',
      'lunch box': 'Brotdose',
      'lunchbox': 'Brotdose',
      'cooler bag': 'Kühltasche',
      
      // === BABY CARE ===
      'pacifier': 'Schnuller',
      'dummy': 'Schnuller',
      'soother': 'Schnuller',
      'teether': 'Beißring',
      'teething ring': 'Beißring',
      'diaper': 'Windel',
      'diapers': 'Windeln',
      'nappy': 'Windel',
      'nappies': 'Windeln',
      'baby monitor': 'Babyphone',
      'monitor': 'Babyphone',
      'bath': 'Bad',
      'baby bath': 'Babybadewanne',
      'bathtub': 'Badewanne',
      'bath tub': 'Badewanne',
      'towel': 'Handtuch',
      'towels': 'Handtücher',
      'hooded towel': 'Kapuzenhandtuch',
      'baby towel': 'Babyhandtuch',
      'washcloth': 'Waschlappen',
      
      // === SLEEPING ===
      'sleeping bag': 'Schlafsack',
      'sleep sack': 'Schlafsack',
      'baby sleeping bag': 'Babyschlafsack',
      'swaddle': 'Pucksack',
      'blanket': 'Decke',
      'blankets': 'Decken',
      'baby blanket': 'Babydecke',
      'throw': 'Kuscheldecke',
      'mobile': 'Mobile',
      'baby mobile': 'Mobile',
      
      // === CLOTHING ===
      'clothes': 'Kleidung',
      'clothing': 'Kleidung',
      'outfit': 'Outfit',
      'bodysuit': 'Body',
      'body': 'Body',
      'onesie': 'Strampler',
      'romper': 'Strampler',
      'jumpsuit': 'Overall',
      'overall': 'Overall',
      'overalls': 'Overall',
      'dungarees': 'Latzhose',
      'dress': 'Kleid',
      'dresses': 'Kleider',
      'skirt': 'Rock',
      'pants': 'Hose',
      'trousers': 'Hose',
      'leggings': 'Leggings',
      'jeans': 'Jeans',
      'shorts': 'Shorts',
      'shirt': 'Hemd',
      't-shirt': 'T-Shirt',
      'tee': 'T-Shirt',
      'top': 'Oberteil',
      'blouse': 'Bluse',
      'sweater': 'Pullover',
      'pullover': 'Pullover',
      'jumper': 'Pullover',
      'cardigan': 'Strickjacke',
      'hoodie': 'Kapuzenpullover',
      'sweatshirt': 'Sweatshirt',
      'jacket': 'Jacke',
      'jackets': 'Jacken',
      'coat': 'Mantel',
      'winter jacket': 'Winterjacke',
      'ski jacket': 'Skijacke',
      'down jacket': 'Daunenjacke',
      'bomber jacket': 'Bomberjacke',
      'rain jacket': 'Regenjacke',
      'raincoat': 'Regenmantel',
      'rain pants': 'Regenhose',
      'rain suit': 'Regenanzug',
      'thermal jacket': 'Thermojacke',
      'fleece': 'Fleece',
      'vest': 'Weste',
      'gilet': 'Weste',
      'snowsuit': 'Schneeanzug',
      'snow pants': 'Schneehose',
      'ski pants': 'Skihose',
      
      // === ACCESSORIES ===
      'accessories': 'Accessoires',
      'hat': 'Mütze',
      'hats': 'Mützen',
      'cap': 'Kappe',
      'beanie': 'Mütze',
      'knit hat': 'Strickmütze',
      'sun hat': 'Sonnenhut',
      'winter hat': 'Wintermütze',
      'balaclava': 'Sturmhaube',
      'scarf': 'Schal',
      'scarves': 'Schals',
      'neck scarf': 'Rundschal',
      'snood': 'Rundschal',
      'gloves': 'Handschuhe',
      'mittens': 'Fäustlinge',
      'socks': 'Socken',
      'tights': 'Strumpfhose',
      'shoes': 'Schuhe',
      'boots': 'Stiefel',
      'winter boots': 'Winterstiefel',
      'rain boots': 'Gummistiefel',
      'rubber boots': 'Gummistiefel',
      'wellies': 'Gummistiefel',
      'slippers': 'Hausschuhe',
      'sandals': 'Sandalen',
      'sneakers': 'Sneaker',
      'trainers': 'Turnschuhe',
      'helmet': 'Helm',
      "children's helmet": 'Kinderhelm',
      'bike helmet': 'Fahrradhelm',
      'sunglasses': 'Sonnenbrille',
      
      // === BAGS ===
      'bag': 'Tasche',
      'bags': 'Taschen',
      'backpack': 'Rucksack',
      'school backpack': 'Schulrucksack',
      'diaper bag': 'Wickeltasche',
      'changing bag': 'Wickeltasche',
      'shoulder bag': 'Schultertasche',
      'tote bag': 'Tragetasche',
      'travel bag': 'Reisetasche',
      'suitcase': 'Koffer',
      'travel suitcase': 'Reisekoffer',
      'pencil case': 'Federtasche',
      'pencil pouch': 'Federmäppchen',
      
      // === TOYS & PLAY ===
      'toy': 'Spielzeug',
      'toys': 'Spielzeug',
      'play': 'Spielen',
      'game': 'Spiel',
      'games': 'Spiele',
      'puzzle': 'Puzzle',
      'puzzles': 'Puzzles',
      'building blocks': 'Bausteine',
      'blocks': 'Bausteine',
      'lego': 'Lego',
      'doll': 'Puppe',
      'dolls': 'Puppen',
      'dollhouse': 'Puppenhaus',
      'teddy': 'Teddy',
      'teddy bear': 'Teddybär',
      'stuffed animal': 'Kuscheltier',
      'plush': 'Plüsch',
      'soft toy': 'Kuscheltier',
      'cuddly toy': 'Kuscheltier',
      'rattle': 'Rassel',
      'wooden toy': 'Holzspielzeug',
      'wooden toys': 'Holzspielzeug',
      'role play': 'Rollenspiel',
      'pretend play': 'Rollenspiel',
      'play kitchen': 'Spielküche',
      'play mat': 'Spielmatte',
      'playmat': 'Spielmatte',
      'activity mat': 'Spieldecke',
      'playpen': 'Laufstall',
      'bouncer': 'Wippe',
      'baby bouncer': 'Babywippe',
      'rocker': 'Schaukelstuhl',
      'swing': 'Schaukel',
      'baby swing': 'Babyschaukel',
      'ball': 'Ball',
      'balls': 'Bälle',
      'book': 'Buch',
      'books': 'Bücher',
      'coloring book': 'Malbuch',
      'music': 'Musik',
      'musical toy': 'Musikspielzeug',
      
      // === STORAGE ===
      'storage': 'Aufbewahrung',
      'storage box': 'Aufbewahrungskiste',
      'storage boxes': 'Aufbewahrungskisten',
      'storage basket': 'Aufbewahrungskorb',
      'storage baskets': 'Aufbewahrungskörbe',
      'storage bag': 'Aufbewahrungssack',
      'storage bags': 'Aufbewahrungssäcke',
      'basket': 'Korb',
      'baskets': 'Körbe',
      'box': 'Kiste',
      'boxes': 'Kisten',
      'container': 'Behälter',
      'organizer': 'Organizer',
      
      // === MATERIALS ===
      'wooden': 'Holz',
      'wood': 'Holz',
      'organic': 'Bio',
      'cotton': 'Baumwolle',
      'linen': 'Leinen',
      'wool': 'Wolle',
      'silk': 'Seide',
      'bamboo': 'Bambus',
      'natural': 'natürlich',
      'eco': 'öko',
      'sustainable': 'nachhaltig',
      
      // === COLORS ===
      'white': 'weiß',
      'black': 'schwarz',
      'gray': 'grau',
      'grey': 'grau',
      'beige': 'beige',
      'brown': 'braun',
      'blue': 'blau',
      'navy': 'navy',
      'green': 'grün',
      'pink': 'rosa',
      'red': 'rot',
      'yellow': 'gelb',
      'orange': 'orange',
      'purple': 'lila',
      
      // === SEASONS/OCCASIONS ===
      'summer': 'Sommer',
      'spring': 'Frühling',
      'autumn': 'Herbst',
      'fall': 'Herbst',
      'christmas': 'Weihnachten',
      'easter': 'Ostern',
      'birthday': 'Geburtstag',
      'advent calendar': 'Adventskalender',
      
      // === BRANDS (common searches) ===
      'liewood': 'Liewood',
      'konges slojd': 'Konges Sløjd',
      'konges sløjd': 'Konges Sløjd',
      'oliver furniture': 'Oliver Furniture',
      'stokke': 'Stokke',
      'cybex': 'Cybex',
      'bugaboo': 'Bugaboo',
      'joolz': 'Joolz',
      'nuna': 'Nuna',
      'cam cam': 'Cam Cam',
      'ferm living': 'Ferm Living',
      'maileg': 'Maileg',
      'rice': 'Rice',
      'wigiwama': 'Wigiwama',
      'lorena canals': 'Lorena Canals',
      
      // === GENERAL TERMS ===
      'baby': 'Baby',
      'child': 'Kind',
      'children': 'Kinder',
      'kids': 'Kinder',
      'toddler': 'Kleinkind',
      'newborn': 'Neugeborenes',
      'infant': 'Säugling',
      'boy': 'Junge',
      'girl': 'Mädchen',
      'unisex': 'Unisex',
      'new arrival': 'Neuheit',
      'new arrivals': 'Neuheiten',
      'bestseller': 'Bestseller',
      'bestsellers': 'Bestseller',
      'popular': 'beliebt',
      'voucher': 'Gutschein',
      'gift card': 'Geschenkkarte',
      'set': 'Set',
      'collection': 'Kollektion',
      'series': 'Serie'
    },
    // French to German - Comprehensive dictionary
    'fr': {
      // === MAIN MENU CATEGORIES ===
      'nouveau': 'Neu',
      'nouveautés': 'Neuheiten',
      'hiver': 'Winter',
      'meubles enfants': 'Kindermöbel',
      'mobilier enfant': 'Kindermöbel',
      'maison et déco': 'Home & Deko',
      'décoration': 'Dekoration',
      'déco': 'Deko',
      'équipement bébé': 'Babyausstattung',
      'poussettes et sièges auto': 'Kinderwagen & Autositze',
      'mode': 'Mode',
      'jouer': 'Spielen',
      'jeux': 'Spiele',
      'inspiration': 'Inspiration',
      'cadeaux': 'Geschenke',
      'cadeau': 'Geschenk',
      'soldes': 'Sale',
      'marques': 'Marken',
      'marque': 'Marke',
      
      // === FURNITURE ===
      'meubles': 'Möbel',
      'chambre bébé': 'Babyzimmer',
      'chambre enfant': 'Kinderzimmer',
      'chambre enfants': 'Kinderzimmer',
      'salle de jeux': 'Spielzimmer',
      'lit': 'Bett',
      'lits': 'Betten',
      'lit bébé': 'Babybett',
      'berceau': 'Wiege',
      'couffin': 'Stubenwagen',
      'lit enfant': 'Kinderbett',
      'lit junior': 'Juniorbett',
      'lit superposé': 'Etagenbett',
      'lit mezzanine': 'Hochbett',
      'lit cabane': 'Hausbett',
      'lit au sol': 'Bodenbett',
      'ciel de lit': 'Betthimmel',
      'baldaquin': 'Betthimmel',
      'matelas': 'Matratze',
      'oreiller': 'Kissen',
      'oreillers': 'Kissen',
      'coussin': 'Kissen',
      'coussins': 'Kissen',
      'literie': 'Bettwäsche',
      'linge de lit': 'Bettwäsche',
      'couette': 'Bettdecke',
      'drap': 'Bettlaken',
      'draps': 'Bettlaken',
      'drap housse': 'Spannbettlaken',
      'tour de lit': 'Bettnestchen',
      'armoire': 'Kleiderschrank',
      'commode': 'Kommode',
      'tiroir': 'Schublade',
      'étagère': 'Regal',
      'étagères': 'Regale',
      'bibliothèque': 'Bücherregal',
      'table à langer': 'Wickeltisch',
      'matelas à langer': 'Wickelauflage',
      'bureau': 'Schreibtisch',
      'chaise': 'Stuhl',
      'chaises': 'Stühle',
      'table': 'Tisch',
      'tables': 'Tische',
      'lampe': 'Lampe',
      'lampes': 'Lampen',
      'veilleuse': 'Nachtlicht',
      'tapis': 'Teppich',
      'rideau': 'Vorhang',
      'rideaux': 'Vorhänge',
      
      // === STROLLERS & MOBILITY ===
      'poussette': 'Kinderwagen',
      'poussettes': 'Kinderwagen',
      'landau': 'Kinderwagen',
      'buggy': 'Buggy',
      'poussette 3 roues': '3 Rad Kinderwagen',
      'siège auto': 'Autositz',
      'sièges auto': 'Autositze',
      'cosy': 'Babyschale',
      'coque': 'Babyschale',
      'porte-bébé': 'Babytrage',
      'écharpe de portage': 'Tragetuch',
      'nacelle': 'Babywanne',
      
      // === FEEDING ===
      'chaise haute': 'Hochstuhl',
      'rehausseur': 'Sitzerhöhung',
      'biberon': 'Babyflasche',
      'biberons': 'Babyflaschen',
      'bavoir': 'Lätzchen',
      'bavoirs': 'Lätzchen',
      'tasse': 'Becher',
      'gobelet': 'Trinklernbecher',
      'assiette': 'Teller',
      'bol': 'Schüssel',
      'couverts': 'Besteck',
      'cuillère': 'Löffel',
      'fourchette': 'Gabel',
      'boîte à goûter': 'Brotdose',
      'lunch box': 'Brotdose',
      'sac isotherme': 'Kühltasche',
      
      // === BABY CARE ===
      'tétine': 'Schnuller',
      'sucette': 'Schnuller',
      'anneau de dentition': 'Beißring',
      'couche': 'Windel',
      'couches': 'Windeln',
      'babyphone': 'Babyphone',
      'écoute-bébé': 'Babyphone',
      'bain': 'Bad',
      'baignoire bébé': 'Babybadewanne',
      'serviette': 'Handtuch',
      'serviettes': 'Handtücher',
      'cape de bain': 'Kapuzenhandtuch',
      'gant de toilette': 'Waschlappen',
      
      // === SLEEPING ===
      'gigoteuse': 'Schlafsack',
      'turbulette': 'Schlafsack',
      'emmaillotage': 'Pucksack',
      'couverture': 'Decke',
      'couvertures': 'Decken',
      'couverture bébé': 'Babydecke',
      'plaid': 'Kuscheldecke',
      'mobile': 'Mobile',
      
      // === CLOTHING ===
      'vêtements': 'Kleidung',
      'tenue': 'Outfit',
      'body': 'Body',
      'bodies': 'Bodys',
      'grenouillère': 'Strampler',
      'pyjama': 'Schlafanzug',
      'combinaison': 'Overall',
      'salopette': 'Latzhose',
      'robe': 'Kleid',
      'robes': 'Kleider',
      'jupe': 'Rock',
      'pantalon': 'Hose',
      'legging': 'Leggings',
      'leggings': 'Leggings',
      'jean': 'Jeans',
      'short': 'Shorts',
      'chemise': 'Hemd',
      't-shirt': 'T-Shirt',
      'tee-shirt': 'T-Shirt',
      'haut': 'Oberteil',
      'blouse': 'Bluse',
      'pull': 'Pullover',
      'pullover': 'Pullover',
      'gilet': 'Strickjacke',
      'cardigan': 'Strickjacke',
      'sweat': 'Sweatshirt',
      'sweat à capuche': 'Kapuzenpullover',
      'veste': 'Jacke',
      'vestes': 'Jacken',
      'manteau': 'Mantel',
      'doudoune': 'Daunenjacke',
      'blouson': 'Bomberjacke',
      'imperméable': 'Regenjacke',
      'veste de pluie': 'Regenjacke',
      'pantalon de pluie': 'Regenhose',
      'combinaison de pluie': 'Regenanzug',
      'polaire': 'Fleece',
      'combinaison de ski': 'Schneeanzug',
      'combinaison de neige': 'Schneeanzug',
      'pantalon de ski': 'Skihose',
      'pantalon de neige': 'Schneehose',
      
      // === ACCESSORIES ===
      'accessoires': 'Accessoires',
      'bonnet': 'Mütze',
      'bonnets': 'Mützen',
      'casquette': 'Kappe',
      'chapeau': 'Hut',
      'chapeau de soleil': 'Sonnenhut',
      'cagoule': 'Sturmhaube',
      'écharpe': 'Schal',
      'écharpes': 'Schals',
      'snood': 'Rundschal',
      'gants': 'Handschuhe',
      'moufles': 'Fäustlinge',
      'chaussettes': 'Socken',
      'collants': 'Strumpfhose',
      'chaussures': 'Schuhe',
      'bottes': 'Stiefel',
      'bottes de neige': 'Winterstiefel',
      'bottes de pluie': 'Gummistiefel',
      'chaussons': 'Hausschuhe',
      'sandales': 'Sandalen',
      'baskets': 'Sneaker',
      'casque': 'Helm',
      'casque vélo': 'Fahrradhelm',
      'lunettes de soleil': 'Sonnenbrille',
      
      // === BAGS ===
      'sac': 'Tasche',
      'sacs': 'Taschen',
      'sac à dos': 'Rucksack',
      'cartable': 'Schulrucksack',
      'sac à langer': 'Wickeltasche',
      'sac bandoulière': 'Schultertasche',
      'sac de voyage': 'Reisetasche',
      'valise': 'Koffer',
      'trousse': 'Federtasche',
      
      // === TOYS ===
      'jouet': 'Spielzeug',
      'jouets': 'Spielzeug',
      'jeu': 'Spiel',
      'puzzle': 'Puzzle',
      'puzzles': 'Puzzles',
      'blocs': 'Bausteine',
      'cubes': 'Bausteine',
      'poupée': 'Puppe',
      'poupées': 'Puppen',
      'maison de poupée': 'Puppenhaus',
      'nounours': 'Teddybär',
      'peluche': 'Kuscheltier',
      'peluches': 'Kuscheltiere',
      'doudou': 'Kuscheltier',
      'hochet': 'Rassel',
      'jouet en bois': 'Holzspielzeug',
      'jouets en bois': 'Holzspielzeug',
      'jeu de rôle': 'Rollenspiel',
      'cuisine jouet': 'Spielküche',
      'tapis de jeu': 'Spielmatte',
      'tapis d\'éveil': 'Spieldecke',
      'parc': 'Laufstall',
      'transat': 'Wippe',
      'balançoire': 'Schaukel',
      'ballon': 'Ball',
      'ballons': 'Bälle',
      'livre': 'Buch',
      'livres': 'Bücher',
      'coloriage': 'Malbuch',
      
      // === STORAGE ===
      'rangement': 'Aufbewahrung',
      'boîte de rangement': 'Aufbewahrungskiste',
      'panier': 'Korb',
      'paniers': 'Körbe',
      'panier de rangement': 'Aufbewahrungskorb',
      'sac de rangement': 'Aufbewahrungssack',
      'boîte': 'Kiste',
      
      // === MATERIALS ===
      'bois': 'Holz',
      'en bois': 'Holz',
      'bio': 'Bio',
      'coton': 'Baumwolle',
      'lin': 'Leinen',
      'laine': 'Wolle',
      'soie': 'Seide',
      'bambou': 'Bambus',
      'naturel': 'natürlich',
      'écologique': 'öko',
      'durable': 'nachhaltig',
      
      // === COLORS ===
      'blanc': 'weiß',
      'noir': 'schwarz',
      'gris': 'grau',
      'beige': 'beige',
      'marron': 'braun',
      'bleu': 'blau',
      'vert': 'grün',
      'rose': 'rosa',
      'rouge': 'rot',
      'jaune': 'gelb',
      'orange': 'orange',
      'violet': 'lila',
      
      // === SEASONS ===
      'été': 'Sommer',
      'printemps': 'Frühling',
      'automne': 'Herbst',
      'noël': 'Weihnachten',
      'pâques': 'Ostern',
      'anniversaire': 'Geburtstag',
      'calendrier de l\'avent': 'Adventskalender',
      
      // === GENERAL ===
      'bébé': 'Baby',
      'enfant': 'Kind',
      'enfants': 'Kinder',
      'tout-petit': 'Kleinkind',
      'nouveau-né': 'Neugeborenes',
      'nourrisson': 'Säugling',
      'garçon': 'Junge',
      'fille': 'Mädchen',
      'unisexe': 'Unisex',
      'meilleures ventes': 'Bestseller',
      'populaire': 'beliebt',
      'bon': 'Gutschein',
      'carte cadeau': 'Geschenkkarte',
      'ensemble': 'Set',
      'collection': 'Kollektion'
    },
    // Italian to German - Comprehensive dictionary
    'it': {
      // === MAIN MENU CATEGORIES ===
      'nuovo': 'Neu',
      'novità': 'Neuheiten',
      'inverno': 'Winter',
      'mobili bambini': 'Kindermöbel',
      'arredamento bambini': 'Kindermöbel',
      'casa e decorazioni': 'Home & Deko',
      'decorazione': 'Dekoration',
      'decorazioni': 'Dekoration',
      'attrezzatura neonato': 'Babyausstattung',
      'passeggini e seggiolini': 'Kinderwagen & Autositze',
      'moda': 'Mode',
      'giocare': 'Spielen',
      'giochi': 'Spiele',
      'ispirazione': 'Inspiration',
      'regali': 'Geschenke',
      'regalo': 'Geschenk',
      'saldi': 'Sale',
      'sconti': 'Sale',
      'marche': 'Marken',
      'marca': 'Marke',
      
      // === FURNITURE ===
      'mobili': 'Möbel',
      'cameretta neonato': 'Babyzimmer',
      'cameretta bambini': 'Kinderzimmer',
      'cameretta': 'Kinderzimmer',
      'sala giochi': 'Spielzimmer',
      'letto': 'Bett',
      'letti': 'Betten',
      'lettino': 'Babybett',
      'culla': 'Wiege',
      'navicella': 'Stubenwagen',
      'letto bambino': 'Kinderbett',
      'letto junior': 'Juniorbett',
      'letto a castello': 'Etagenbett',
      'letto a soppalco': 'Hochbett',
      'letto casetta': 'Hausbett',
      'letto montessori': 'Bodenbett',
      'baldacchino': 'Betthimmel',
      'materasso': 'Matratze',
      'cuscino': 'Kissen',
      'cuscini': 'Kissen',
      'biancheria da letto': 'Bettwäsche',
      'lenzuola': 'Bettwäsche',
      'piumino': 'Bettdecke',
      'lenzuolo': 'Bettlaken',
      'lenzuolo con angoli': 'Spannbettlaken',
      'paracolpi': 'Bettnestchen',
      'armadio': 'Kleiderschrank',
      'cassettiera': 'Kommode',
      'cassetto': 'Schublade',
      'mensola': 'Regal',
      'mensole': 'Regale',
      'libreria': 'Bücherregal',
      'fasciatoio': 'Wickeltisch',
      'materassino fasciatoio': 'Wickelauflage',
      'scrivania': 'Schreibtisch',
      'sedia': 'Stuhl',
      'sedie': 'Stühle',
      'tavolo': 'Tisch',
      'tavoli': 'Tische',
      'lampada': 'Lampe',
      'lampade': 'Lampen',
      'luce notturna': 'Nachtlicht',
      'tappeto': 'Teppich',
      'tenda': 'Vorhang',
      'tende': 'Vorhänge',
      
      // === STROLLERS & MOBILITY ===
      'passeggino': 'Kinderwagen',
      'passeggini': 'Kinderwagen',
      'carrozzina': 'Kinderwagen',
      'buggy': 'Buggy',
      'passeggino 3 ruote': '3 Rad Kinderwagen',
      'seggiolino auto': 'Autositz',
      'seggiolini auto': 'Autositze',
      'ovetto': 'Babyschale',
      'marsupio': 'Babytrage',
      'fascia porta bebè': 'Tragetuch',
      'navicella': 'Babywanne',
      
      // === FEEDING ===
      'seggiolone': 'Hochstuhl',
      'rialzo sedia': 'Sitzerhöhung',
      'biberon': 'Babyflasche',
      'bavaglino': 'Lätzchen',
      'bavaglini': 'Lätzchen',
      'tazza': 'Becher',
      'bicchiere': 'Trinklernbecher',
      'piatto': 'Teller',
      'ciotola': 'Schüssel',
      'posate': 'Besteck',
      'cucchiaio': 'Löffel',
      'forchetta': 'Gabel',
      'porta pranzo': 'Brotdose',
      'lunch box': 'Brotdose',
      'borsa termica': 'Kühltasche',
      
      // === BABY CARE ===
      'ciuccio': 'Schnuller',
      'succhietto': 'Schnuller',
      'massaggiagengive': 'Beißring',
      'dentaruolo': 'Beißring',
      'pannolino': 'Windel',
      'pannolini': 'Windeln',
      'baby monitor': 'Babyphone',
      'bagno': 'Bad',
      'vaschetta bagnetto': 'Babybadewanne',
      'asciugamano': 'Handtuch',
      'asciugamani': 'Handtücher',
      'accappatoio neonato': 'Kapuzenhandtuch',
      'guanto da bagno': 'Waschlappen',
      
      // === SLEEPING ===
      'sacco nanna': 'Schlafsack',
      'sacco a pelo': 'Schlafsack',
      'fasciatura': 'Pucksack',
      'coperta': 'Decke',
      'coperte': 'Decken',
      'coperta neonato': 'Babydecke',
      'plaid': 'Kuscheldecke',
      'giostrina': 'Mobile',
      
      // === CLOTHING ===
      'vestiti': 'Kleidung',
      'abbigliamento': 'Kleidung',
      'completo': 'Outfit',
      'body': 'Body',
      'tutina': 'Strampler',
      'pigiama': 'Schlafanzug',
      'tuta': 'Overall',
      'salopette': 'Latzhose',
      'abito': 'Kleid',
      'vestito': 'Kleid',
      'gonna': 'Rock',
      'pantaloni': 'Hose',
      'leggings': 'Leggings',
      'jeans': 'Jeans',
      'shorts': 'Shorts',
      'camicia': 'Hemd',
      't-shirt': 'T-Shirt',
      'maglietta': 'T-Shirt',
      'maglia': 'Oberteil',
      'camicetta': 'Bluse',
      'maglione': 'Pullover',
      'cardigan': 'Strickjacke',
      'felpa': 'Sweatshirt',
      'felpa con cappuccio': 'Kapuzenpullover',
      'giacca': 'Jacke',
      'giacche': 'Jacken',
      'cappotto': 'Mantel',
      'piumino': 'Daunenjacke',
      'bomber': 'Bomberjacke',
      'impermeabile': 'Regenjacke',
      'giacca antipioggia': 'Regenjacke',
      'pantaloni antipioggia': 'Regenhose',
      'tuta antipioggia': 'Regenanzug',
      'pile': 'Fleece',
      'tuta da sci': 'Schneeanzug',
      'tuta da neve': 'Schneeanzug',
      'pantaloni da sci': 'Skihose',
      'pantaloni da neve': 'Schneehose',
      'gilet': 'Weste',
      
      // === ACCESSORIES ===
      'accessori': 'Accessoires',
      'berretto': 'Mütze',
      'berretti': 'Mützen',
      'cappello': 'Hut',
      'cappellino': 'Kappe',
      'cappello da sole': 'Sonnenhut',
      'passamontagna': 'Sturmhaube',
      'sciarpa': 'Schal',
      'sciarpe': 'Schals',
      'scaldacollo': 'Rundschal',
      'guanti': 'Handschuhe',
      'muffole': 'Fäustlinge',
      'calzini': 'Socken',
      'collant': 'Strumpfhose',
      'scarpe': 'Schuhe',
      'stivali': 'Stiefel',
      'stivali da neve': 'Winterstiefel',
      'stivali da pioggia': 'Gummistiefel',
      'pantofole': 'Hausschuhe',
      'sandali': 'Sandalen',
      'sneakers': 'Sneaker',
      'casco': 'Helm',
      'casco bici': 'Fahrradhelm',
      'occhiali da sole': 'Sonnenbrille',
      
      // === BAGS ===
      'borsa': 'Tasche',
      'borse': 'Taschen',
      'zaino': 'Rucksack',
      'zaino scuola': 'Schulrucksack',
      'borsa fasciatoio': 'Wickeltasche',
      'borsa a tracolla': 'Schultertasche',
      'borsa da viaggio': 'Reisetasche',
      'valigia': 'Koffer',
      'astuccio': 'Federtasche',
      
      // === TOYS ===
      'giocattolo': 'Spielzeug',
      'giocattoli': 'Spielzeug',
      'gioco': 'Spiel',
      'puzzle': 'Puzzle',
      'costruzioni': 'Bausteine',
      'mattoncini': 'Bausteine',
      'bambola': 'Puppe',
      'bambole': 'Puppen',
      'casa delle bambole': 'Puppenhaus',
      'orsetto': 'Teddybär',
      'peluche': 'Kuscheltier',
      'pupazzo': 'Kuscheltier',
      'pupazzi': 'Kuscheltiere',
      'sonaglio': 'Rassel',
      'giocattolo in legno': 'Holzspielzeug',
      'giocattoli in legno': 'Holzspielzeug',
      'gioco di ruolo': 'Rollenspiel',
      'cucina giocattolo': 'Spielküche',
      'tappeto gioco': 'Spielmatte',
      'palestrina': 'Spieldecke',
      'box': 'Laufstall',
      'sdraietta': 'Wippe',
      'altalena': 'Schaukel',
      'palla': 'Ball',
      'pallone': 'Ball',
      'libro': 'Buch',
      'libri': 'Bücher',
      'album da colorare': 'Malbuch',
      
      // === STORAGE ===
      'contenitore': 'Aufbewahrung',
      'scatola': 'Kiste',
      'scatole': 'Kisten',
      'cesta': 'Korb',
      'ceste': 'Körbe',
      'cesto portaoggetti': 'Aufbewahrungskorb',
      'sacco portaoggetti': 'Aufbewahrungssack',
      
      // === MATERIALS ===
      'legno': 'Holz',
      'in legno': 'Holz',
      'biologico': 'Bio',
      'cotone': 'Baumwolle',
      'lino': 'Leinen',
      'lana': 'Wolle',
      'seta': 'Seide',
      'bambù': 'Bambus',
      'naturale': 'natürlich',
      'ecologico': 'öko',
      'sostenibile': 'nachhaltig',
      
      // === COLORS ===
      'bianco': 'weiß',
      'nero': 'schwarz',
      'grigio': 'grau',
      'beige': 'beige',
      'marrone': 'braun',
      'blu': 'blau',
      'verde': 'grün',
      'rosa': 'rosa',
      'rosso': 'rot',
      'giallo': 'gelb',
      'arancione': 'orange',
      'viola': 'lila',
      
      // === SEASONS ===
      'estate': 'Sommer',
      'primavera': 'Frühling',
      'autunno': 'Herbst',
      'natale': 'Weihnachten',
      'pasqua': 'Ostern',
      'compleanno': 'Geburtstag',
      'calendario dell\'avvento': 'Adventskalender',
      
      // === GENERAL ===
      'bambino': 'Kind',
      'bambini': 'Kinder',
      'neonato': 'Baby',
      'bebè': 'Baby',
      'bimbo piccolo': 'Kleinkind',
      'lattante': 'Säugling',
      'maschio': 'Junge',
      'femmina': 'Mädchen',
      'unisex': 'Unisex',
      'più venduti': 'Bestseller',
      'popolare': 'beliebt',
      'buono': 'Gutschein',
      'carta regalo': 'Geschenkkarte',
      'set': 'Set',
      'collezione': 'Kollektion'
    }
  };

  /**
   * Check dictionary for direct translation
   */
  function getDictionaryTranslation(query, sourceLang) {
    var dict = PRODUCT_DICTIONARY[sourceLang];
    if (!dict) return null;
    
    var normalizedQuery = query.toLowerCase().trim();
    
    // Direct match
    if (dict[normalizedQuery]) {
      return dict[normalizedQuery];
    }
    
    // Try to match parts of multi-word queries
    var words = normalizedQuery.split(/\s+/);
    if (words.length > 1) {
      // Check if full phrase exists
      var phrase = words.join(' ');
      if (dict[phrase]) {
        return dict[phrase];
      }
    }
    
    return null;
  }

  /**
   * Normalize query - decode URL encoding, handle + as space
   */
  function normalizeQuery(query) {
    if (!query) return '';
    // Replace + with space
    var normalized = query.replace(/\+/g, ' ');
    // Decode any URL encoding
    try {
      normalized = decodeURIComponent(normalized);
    } catch (e) {}
    // Trim and normalize spaces
    return normalized.trim().replace(/\s+/g, ' ');
  }

  /**
   * Get current page language from GTranslate
   */
  function getCurrentLanguage() {
    // Try to get language from URL (en.mysnowflake.ch)
    var hostname = window.location.hostname;
    var subdomain = hostname.split('.')[0];
    if (['en', 'fr', 'it'].indexOf(subdomain) !== -1) {
      return subdomain;
    }
    
    // Try to get from html lang attribute
    var htmlLang = document.documentElement.lang;
    if (htmlLang && htmlLang.length >= 2) {
      return htmlLang.substring(0, 2).toLowerCase();
    }
    
    // Try to get from GTranslate cookie
    try {
      var match = document.cookie.match(/googtrans=\/[^\/]+\/([^;]+)/);
      if (match && match[1]) {
        return match[1];
      }
    } catch (e) {}
    
    return DEFAULT_LANGUAGE;
  }

  /**
   * Check if translation is needed
   */
  function needsTranslation() {
    var lang = getCurrentLanguage();
    return lang !== DEFAULT_LANGUAGE;
  }

  /**
   * Get cached translation
   */
  function getCachedTranslation(query, sourceLang) {
    try {
      var cacheKey = CACHE_PREFIX + sourceLang + '_' + query.toLowerCase();
      var cached = localStorage.getItem(cacheKey);
      if (cached) {
        var data = JSON.parse(cached);
        if (data.expiry > Date.now()) {
          return data.translation;
        }
        localStorage.removeItem(cacheKey);
      }
    } catch (e) {}
    return null;
  }

  /**
   * Set cached translation
   */
  function setCachedTranslation(query, sourceLang, translation) {
    try {
      var cacheKey = CACHE_PREFIX + sourceLang + '_' + query.toLowerCase();
      var data = {
        translation: translation,
        expiry: Date.now() + CACHE_EXPIRY
      };
      localStorage.setItem(cacheKey, JSON.stringify(data));
    } catch (e) {}
  }

  /**
   * Translate query using dictionary first, then API
   */
  function translateQuery(query, sourceLang, callback) {
    // Normalize the query first
    var normalizedQuery = normalizeQuery(query);
    
    // Check dictionary first (instant, no API call)
    var dictTranslation = getDictionaryTranslation(normalizedQuery, sourceLang);
    if (dictTranslation) {
      console.log('Boost PFS Search Translate: Dictionary match "' + normalizedQuery + '" -> "' + dictTranslation + '"');
      callback(dictTranslation);
      return;
    }
    
    // Check cache
    var cached = getCachedTranslation(normalizedQuery, sourceLang);
    if (cached) {
      console.log('Boost PFS Search Translate: Using cached translation:', normalizedQuery, '->', cached);
      callback(cached);
      return;
    }

    // Check if this translation is already pending
    var pendingKey = sourceLang + '_' + normalizedQuery.toLowerCase();
    if (pendingTranslations[pendingKey]) {
      pendingTranslations[pendingKey].push(callback);
      return;
    }
    pendingTranslations[pendingKey] = [callback];

    // Skip if API key not configured
    if (TRANSLATEX_API_KEY === 'YOUR_API_KEY_HERE') {
      console.warn('Boost PFS Search Translate: API key not configured');
      resolveTranslation(pendingKey, normalizedQuery, sourceLang, normalizedQuery);
      return;
    }

    // Build the API URL
    var apiUrl = TRANSLATEX_API_URL + 
                 '?sl=' + encodeURIComponent(sourceLang) + 
                 '&tl=' + encodeURIComponent(DEFAULT_LANGUAGE) + 
                 '&key=' + encodeURIComponent(TRANSLATEX_API_KEY);
    
    // Use CORS proxy to avoid CORS issues
    var corsProxy = 'https://corsproxy.io/?';
    var proxyUrl = corsProxy + encodeURIComponent(apiUrl);

    console.log('Boost PFS Search Translate: Translating "' + normalizedQuery + '" from ' + sourceLang + ' to ' + DEFAULT_LANGUAGE);

    // Make API request using fetch with POST
    fetch(proxyUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: 'text=' + encodeURIComponent(normalizedQuery)
    })
    .then(function(response) {
      if (!response.ok) {
        throw new Error('HTTP ' + response.status);
      }
      return response.json();
    })
    .then(function(data) {
      if (data.translation && data.translation.length > 0) {
        var translation = data.translation[0];
        console.log('Boost PFS Search Translate: Translated "' + normalizedQuery + '" to "' + translation + '"');
        resolveTranslation(pendingKey, normalizedQuery, sourceLang, translation);
      } else {
        console.warn('Boost PFS Search Translate: No translation in response');
        resolveTranslation(pendingKey, normalizedQuery, sourceLang, normalizedQuery);
      }
    })
    .catch(function(error) {
      console.error('Boost PFS Search Translate: Translation failed:', error);
      // Try alternative CORS proxy
      tryAlternativeProxy(normalizedQuery, sourceLang, pendingKey, apiUrl);
    });
  }

  /**
   * Try alternative CORS proxy if first one fails
   */
  function tryAlternativeProxy(query, sourceLang, pendingKey, apiUrl) {
    var altProxy = 'https://api.allorigins.win/raw?url=';
    var altUrl = altProxy + encodeURIComponent(apiUrl + '&text=' + encodeURIComponent(query));

    fetch(altUrl)
      .then(function(response) {
        return response.json();
      })
      .then(function(data) {
        if (data.translation && data.translation.length > 0) {
          var translation = data.translation[0];
          console.log('Boost PFS Search Translate: Translated (alt proxy) "' + query + '" to "' + translation + '"');
          resolveTranslation(pendingKey, query, sourceLang, translation);
        } else {
          resolveTranslation(pendingKey, query, sourceLang, query);
        }
      })
      .catch(function(error) {
        console.error('Boost PFS Search Translate: All proxies failed:', error);
        resolveTranslation(pendingKey, query, sourceLang, query);
      });
  }

  /**
   * Resolve all pending callbacks for a translation
   */
  function resolveTranslation(pendingKey, query, sourceLang, translation) {
    if (translation !== query) {
      setCachedTranslation(query, sourceLang, translation);
    }
    
    var callbacks = pendingTranslations[pendingKey] || [];
    delete pendingTranslations[pendingKey];
    
    callbacks.forEach(function(cb) {
      try {
        cb(translation);
      } catch (e) {
        console.error('Boost PFS Search Translate: Callback error:', e);
      }
    });
  }

  /**
   * Check if URL is a mybcapps search/suggest request
   */
  function isBoostSearchUrl(url) {
    return url && 
           url.indexOf('services.mybcapps.com') !== -1 && 
           (url.indexOf('/search') !== -1 || url.indexOf('/suggest') !== -1);
  }

  /**
   * Extract query from URL
   */
  function extractQuery(url) {
    var match = url.match(/[?&]q=([^&]*)/);
    if (match) {
      return match[1]; // Return raw, will be normalized later
    }
    return null;
  }

  /**
   * Replace query in URL with translated version
   */
  function replaceQueryInUrl(url, originalQuery, translatedQuery) {
    if (normalizeQuery(originalQuery) === translatedQuery) {
      return url;
    }
    // Find and replace the q parameter
    return url.replace(
      /([?&]q=)[^&]*/,
      '$1' + encodeURIComponent(translatedQuery)
    );
  }

  /**
   * Override native fetch for mybcapps requests
   */
  var originalFetch = window.fetch;
  window.fetch = function(input, init) {
    var url = typeof input === 'string' ? input : (input && input.url);
    
    // Skip if not a boost search URL or no translation needed
    if (!url || !needsTranslation() || !isBoostSearchUrl(url)) {
      return originalFetch.apply(this, arguments);
    }

    var query = extractQuery(url);
    if (!query || normalizeQuery(query).trim() === '') {
      return originalFetch.apply(this, arguments);
    }

    var sourceLang = getCurrentLanguage();
    var self = this;

    return new Promise(function(resolve, reject) {
      translateQuery(query, sourceLang, function(translatedQuery) {
        var newUrl = replaceQueryInUrl(url, query, translatedQuery);
        
        if (typeof input === 'string') {
          originalFetch.call(self, newUrl, init)
            .then(resolve)
            .catch(reject);
        } else {
          try {
            var newInput = new Request(newUrl, input);
            originalFetch.call(self, newInput, init)
              .then(resolve)
              .catch(reject);
          } catch (e) {
            // Fallback if Request construction fails
            originalFetch.call(self, newUrl, init)
              .then(resolve)
              .catch(reject);
          }
        }
      });
    });
  };

  /**
   * Override XMLHttpRequest for mybcapps requests
   */
  var XHROpen = XMLHttpRequest.prototype.open;
  var XHRSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function(method, url, async, user, password) {
    this._boostTranslate = {
      method: method,
      url: url,
      async: async !== false,
      user: user,
      password: password,
      needsTranslation: needsTranslation() && isBoostSearchUrl(url),
      query: extractQuery(url),
      sourceLang: getCurrentLanguage()
    };
    return XHROpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function(body) {
    var self = this;
    var bt = this._boostTranslate;
    
    if (!bt || !bt.needsTranslation || !bt.query || normalizeQuery(bt.query).trim() === '') {
      return XHRSend.apply(this, arguments);
    }

    translateQuery(bt.query, bt.sourceLang, function(translatedQuery) {
      var newUrl = replaceQueryInUrl(bt.url, bt.query, translatedQuery);
      
      // Re-open with new URL
      XHROpen.call(self, bt.method, newUrl, bt.async, bt.user, bt.password);
      XHRSend.call(self, body);
    });
  };

  // Log initialization
  var currentLang = getCurrentLanguage();
  console.log('Boost PFS Search Translate: Initialized for language', currentLang);
  
  if (currentLang !== DEFAULT_LANGUAGE) {
    console.log('Boost PFS Search Translate: Translation is ACTIVE (source: ' + currentLang + ' -> target: ' + DEFAULT_LANGUAGE + ')');
    console.log('Boost PFS Search Translate: Dictionary has', Object.keys(PRODUCT_DICTIONARY[currentLang] || {}).length, 'terms for', currentLang);
  }
  
  // Expose for debugging
  window.BoostSearchTranslate = {
    getCurrentLanguage: getCurrentLanguage,
    needsTranslation: needsTranslation,
    translateQuery: translateQuery,
    getDictionaryTranslation: getDictionaryTranslation,
    normalizeQuery: normalizeQuery,
    clearCache: function() {
      var keys = [];
      for (var i = 0; i < localStorage.length; i++) {
        var key = localStorage.key(i);
        if (key && key.indexOf(CACHE_PREFIX) === 0) {
          keys.push(key);
        }
      }
      keys.forEach(function(k) { localStorage.removeItem(k); });
      console.log('Boost PFS Search Translate: Cleared ' + keys.length + ' cached translations');
    },
    VERSION: '1.3.0'
  };

})();